import React from "react";
import SectionHeader from "../../components/SectionHeader";
import HeaderImage from "../../images/main-banner.png";
import HeaderImage2 from "../../images/banner-side -image.png";
import { Col, Container, Row } from "react-bootstrap";

const About = () => {
  return (
    <>
      <SectionHeader
        title="About Us"
        image={HeaderImage}
        image2={HeaderImage2}
        title2="Detail About Vendor"
        content=""
      ></SectionHeader>
      <div className="about-page pt-5">
        <Container>
          <Row>
            <Col>
              <div className="about-page-content pt-4 pb-5">
                <h1>About Us</h1>
                <p>
                  Since 1979, we've been a trusted partner for independent
                  builders and contractors. Originally founded as Bolt
                  Construction, our company evolved to BOLTCO, LLC in 2020 to
                  serve as the parent company for all our innovative business
                  ventures.
                </p>
                <h1>What We Do</h1>
                <p>
                  Today, we're revolutionizing the building industry through
                  direct manufacturer relationships, cost-saving buying groups,
                  and a user-friendly B2B and B2C sales platform. We specialize
                  in providing comprehensive sales and distribution services to
                  small to mid-sized manufacturers looking to expand their reach
                  in the Texas, Oklahoma, Arkansas, and Louisiana markets. Our
                  services include:
                </p>
                <ul>
                  <li><strong>Warehousing: </strong>Safe and efficient product storage for seamless distribution.</li>
                  <li><strong>Sales Team: </strong>A dedicated inside sales force focused on building strong relationships with local building materials and lumber yards.</li>
                  <li><strong>Direct-to-Manufacturer Relationships:</strong>By eliminating unnecessary intermediaries, we offer our clients better pricing, faster delivery, and superior service.</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default About;
